export default __webpack_public_path__ + "static/media/logo-bg.a03373cf.svg";